import React from "react";
import { Box, Grid2, Typography } from "@mui/material";

import dashboard from "../Images/safetyWalk/dashboard.png";
import wave from "../Images/aboutUsBg.jpg"
import wave2 from "../Images/wave2.svg"

const WaveBackground = ({ menu, title, description }) => {
  return (
    // <Box
    //   sx={{
    //     zIndex:-50,
    //     width: "100%",
    //     height: "83vh",
    //     position: "relative",
    //     "&::after": {
    //       content: '""',
    //       position: "absolute",
    //       bottom: 0,
    //       left: 0,
    //       top:0,
    //       width: "100%",
    //       height: "100%",
    //       backgroundColor: "#fff",
    //       clipPath:
    //         'path("M 0,700 L 0,360 C 131.2,450 262.4,540 426,520 C 589.6,504 785.6,450 960,440 C 1134.4,432 1287.2,486 1440,540 L 2240,810 L 0,810 Z")',
    //     },
    //     "@media (max-width: 768px)": {
    //       // Adjust the max-width as needed for your design
    //       "&::after": {
    //         content: "none", // Removes the ::after element in mobile screens
    //       },
    //     },
    //   }}
    // >
    //   <Box sx={{height: '83vh',
    //   width:"100%",
    // backgroundImage: `url(${wave})`, // Image without gradient directly on the box
    // backgroundSize: 'cover',
    // backgroundPosition: 'left',
    // backgroundRepeat: 'no-repeat',
    // zIndex:-1}} />
    //   <Box
    //     sx={{
    //       position: "absolute",
    //       zIndex: 1,
    //       left: 0,
    //     //   bottom:0,
    //       top: "50%",
    //       transform: "translatey(-50%)",
    //       textTransform: "uppercase",
    //       color: "white",
    //       letterSpacing: "0.175rem",
    //       height: "100%",
    //       background:
    //         // "linear-gradient( rgba(10, 102, 194, 0.7), rgba(10, 102, 194, 0.7))",
    //         // "linear-gradient(to right, rgba(10, 102, 194, 0.6) 0%, rgba(10, 102, 194) 35%, rgba(10, 102, 194, 0.7) 100%)",
    //        " radial-gradient(rgba(10, 102, 194,0.87) 30%, rgba(10, 102, 194, 0.65) 70%)",


    //       width: "100%",
    //       "&::after": {
    //         content: '""',
    //         position: "absolute",
    //         // top: 0,
    //         left: 0,
    //         bottom:-1,
    //         width: "100%",
    //         height: "100%",
    //         backgroundColor: "#fff",
    //         clipPath:
    //           'path("M 0,700 L 0,360 C 131.2,450 262.4,540 426,520 C 589.6,504 785.6,450 960,440 C 1134.4,432 1287.2,486 1440,540 L 2240,810 L 0,810 Z")',
    //       },
    //       "@media (max-width: 768px)": {
    //         // Adjust the max-width as needed for your design
    //         "&::after": {
    //           content: "none", // Removes the ::after element in mobile screens
    //         },
    //       },
    //     }}
    //   ></Box>

    //   <Box
    //     sx={{
    //       display: "flex",
    //       flexDirection: "column",
    //       gap: "2rem",
    //       alignItems: "center",
    //       width: "100%",
    //       // padding: { xs: 0, md: '3rem' },
    //       position: "absolute",
    //       top: "25%",
    //       bottom: 0,
    //       left: 0,
    //       right: 0,
    //       zIndex: 50,
    //     }}
    //   >
    //     <Typography variant="h2" sx={{ fontWeight: 600, color: "#FFFFFF" }}>
    //       {menu}
    //     </Typography>

    //     <Typography
    //       variant="h4"
    //       sx={{
    //         fontWeight: 500,
    //         color: "#E6F7FF",
    //         // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
    //       }}
    //     >
    //       {title}
    //     </Typography>

    //     <Typography variant="h6" sx={{ fontWeight: 400, color: "#FFFFFF" }}>
    //       {description}
    //     </Typography>
    //   </Box>
    // </Box>   
    <Box sx={{p:0,
      
      zIndex:-50,
      backgroundImage:`radial-gradient(circle, rgba(10, 102, 194,0.87) 30%, rgba(10, 102, 194, 0.67) 70%),
          url(${wave})`,
          backgroundSize: 'cover',
    backgroundPosition: 'left',
    backgroundRepeat: 'no-repeat'
    ,width:"100%",
    position:"relative",
    height:{xs:"80vh",sm:"60vh",md:"100vh"}
    }}>
      <Box sx={{display:'flex',justifyContent:"center",width:"100%"}}>
      <Box sx={{height:"70vh",display:"flex",flexDirection:"column",gap:"2rem",alignItems:'center',justifyContent:"center",width:'100%',maxWidth:{xs:"auto",xl:"2000px"},mt:{xs:"10%",sm:0,md:0},padding:"1.5rem"}}>
      <Typography variant="h2" sx={{fontSize:{xs:"2.2rem",md:"2.5rem"}, fontWeight: 600, color: "#FFFFFF" }}>
          {menu}
       </Typography>

        <Typography
          variant="h4"
          
          sx={{
            textAlign:{xs:"center",md:"left"},
            fontWeight: 500,
            color: "#E6F7FF",
            fontSize:{xs:"2rem",md:"2.2rem"}
            // textShadow: '0 0 5px rgba(255, 255, 255, 0.8)'
          }}
        >
          {title}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 400, color: "#FFFFFF" }}>
          {description}
        </Typography>
      </Box>
      </Box>
      <Box sx={{display:{xs:"none",md:"block"}, backgroundImage:`url(${wave2})`,backgroundSize: 'cover', 
    backgroundPosition: 'center',
    position: 'absolute',
    bottom: 0,
    right:0,
    width: '100%',
    height: "100%",  // Adjust as needed
   }}>

      </Box>
    </Box>
  );
};

export default WaveBackground;
